import React, { useEffect, useState } from "react";
import cn from "classnames";
import { ConfigProvider, Pagination } from "antd";
import useDarkMode from "use-dark-mode";
import styles from "./TotesTable.module.sass";
import Checkbox from "../../../../components/Checkbox";
import Card from "../../../../components/Card";
import ToteTableRow from "./Row";
import CustomToast from "../../../../components/CustomToast";
import { FETCH_TOTES_DETAILS } from "../../../../API/Totes";
import { useParams } from "react-router";

const TotesDetailTable = ({
  handleCheckboxChange,
  checkedItems,
  page,
  setPage,
  totalItems,
  setTotalItems,
  itemsPerPage,
  setItemsPerPage,
  refetchTrigger,
  setToteMarkedToDelete,
  setToteMarkedToEmpty,
  setToteCount,
  setToteStatus,
}) => {
  const [data, setData] = useState([]);
  const { toteId } = useParams();
  const darkMode = useDarkMode(false);

  const isAllSelected =
    data.length > 0 && data.every((item) => checkedItems[item.order?.id]);
  const isSomeSelected =
    data.some((item) => checkedItems[item.order?.id]) && !isAllSelected;

  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    const newCheckedItems = {};
    data.forEach((item) => {
      if (item.order?.id) {
        newCheckedItems[item.order.id] = checked;
      }
    });
    handleCheckboxChange(e, newCheckedItems);
  };

  const handlePageChange = (currentPage, pageSize) => {
    setPage(currentPage);
    if (pageSize !== itemsPerPage) {
      setItemsPerPage(pageSize);
    }
  };

  const fetchData = async () => {
    try {
      const queryParams = [
        { key: "page", value: page },
        { key: "pageSize", value: itemsPerPage },
      ];
      const response = await FETCH_TOTES_DETAILS(toteId, queryParams);
      setData(response.result);
      setTotalItems(response.count);
      setToteCount(response.count);
      setToteStatus(response.tote.tote_status)
    } catch (error) {
      CustomToast.fire({
        icon: "error",
        title: "Failed to fetch tote details",
      });
    }
  };

  const themeConfig = {
    token: {
      colorPrimary: "#1890ff",
      colorTextBase: darkMode.value ? "#ffffff" : "#000000",
      colorBgContainer: darkMode.value ? "#1f1f1f" : "#ffffff",
      colorBgElevated: darkMode.value ? "#2f2f2f" : "#ffffff",
      colorText: darkMode.value ? "#ffffff" : "#000000",
      buttonBoxShadow: darkMode.value ? "none" : "0 2px 0 rgb(230, 247, 255)",
      paginationBg: darkMode.value ? "#2f2f2f" : "#ffffff",
      paginationItemBg: darkMode.value ? "#2f2f2f" : "#ffffff",
      paginationItemBgHover: darkMode.value ? "#3a3a3a" : "#f5f5f5",
      paginationItemActiveBg: darkMode.value ? "#3a3a3a" : "#e6f7ff",
      paginationItemLinkBg: darkMode.value ? "#2f2f2f" : "#ffffff",
    },
  };

  useEffect(() => {
    fetchData();
  }, [page, itemsPerPage, refetchTrigger]);

  return (
    <ConfigProvider theme={themeConfig}>
      <div className={styles.market}>
        <Card className={styles.Card}>
          <div>
            <div className={styles.table}>
              <div className={styles.row}>
                <div className={styles.col}>
                  <Checkbox
                    className={styles.checkbox}
                    checked={isAllSelected}
                    indeterminate={isSomeSelected}
                    onChange={handleSelectAll}
                  />
                </div>
                <div className={cn(styles.col)}>Orders</div>
                <div className={cn(styles.col)}></div>
                <div className={cn(styles.col)}></div>
                <div className={cn(styles.col)}></div>
              </div>
              {data.map((item, index) => (
                <ToteTableRow
                  key={index}
                  data={item}
                  checkedItems={checkedItems}
                  handleCheckboxChange={handleCheckboxChange}
                  setToteMarkedToDelete={setToteMarkedToDelete}
                  setToteMarkedToEmpty={setToteMarkedToEmpty}
                />
              ))}
            </div>
          </div>
          <div className={styles.foot}>
            <Pagination
              current={page}
              total={totalItems}
              pageSize={itemsPerPage}
              onChange={handlePageChange}
              onShowSizeChange={(current, size) => {
                setItemsPerPage(size);
                setPage(1);
              }}
              showTotal={(total, range) =>
                `${range[0]}-${range[1]} of ${total} orders`
              }
              showSizeChanger
            />
          </div>
        </Card>
      </div>
    </ConfigProvider>
  );
};

export default TotesDetailTable;
